export default "__VITE_ASSET__a1uRqZG$__"